import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';

function SectionForm({
	title,
	description,
	methods,
	onSubmit,
	loading,
	children
}) {
	const { t } = useTranslation();

	return (
		<FormProvider {...methods}>
			<form
				onSubmit={methods.handleSubmit(onSubmit)}
				className="rounded border border-grey-100"
			>
				<div className="flex flex-col justify-start gap-6 px-4 py-6 lg:flex-row lg:gap-2 lg:p-6 lg:pb-12">
					<div className="flex max-w-[17.75rem] flex-col gap-2 lg:w-1/2 lg:max-w-none">
						<h2 className="text-sm font-semibold leading-6 lg:text-base lg:leading-7">
							{title}
						</h2>
						<p className="max-w-[17.75rem] text-2xs leading-4 text-grey-500 lg:text-xs lg:leading-5 2xl:max-w-[21.25rem]">
							{description}
						</p>
					</div>
					<div className="mb-7 flex w-full max-w-[33.125rem] flex-col items-center justify-center gap-10 rounded-lg bg-white lg:mb-6 lg:w-1/2 lg:max-w-none lg:gap-7">
						{children}
					</div>
				</div>

				<div className="flex items-center justify-end border-t border-grey-100 px-6 py-3">
					<Button type="submit" loading={loading} className="bg-black">
						{t('common.save')}
					</Button>
				</div>
			</form>
		</FormProvider>
	);
}

export default SectionForm;
